import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import {
  getBankDocumentName,
  IBankDocument,
  openBankDocument,
} from "../../../setup/util/internationalBank";
import styles from "./styles.module.scss";

interface Props {
  document?: IBankDocument | null;
}

/** File name + "view" action for an international party's bank document. */
const BankDocumentLink = ({ document }: Props) => {
  const { t } = useTranslation();
  const [opening, setOpening] = useState(false);

  if (!document) {
    return (
      <span className={styles.missing}>
        {t("lbl_international_bank_document_missing")}
      </span>
    );
  }

  const onOpen = async () => {
    setOpening(true);
    try {
      await openBankDocument(document);
    } catch (error) {
      console.error(error);
      toast.error(t("lbl_international_bank_document_error"));
    } finally {
      setOpening(false);
    }
  };

  return (
    <span className={styles.container}>
      <span className={styles.name} dir="auto">
        {getBankDocumentName(document)}
      </span>
      <button
        type="button"
        className={styles.action}
        disabled={opening}
        onClick={onOpen}>
        {t("lbl_org_request_view_document")}
      </button>
    </span>
  );
};

export default BankDocumentLink;
